"use strict";

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@archanova/contracts");

var modules_1 = require("../modules");

var SdkEnvironmentNames;

(function (SdkEnvironmentNames) {
  SdkEnvironmentNames["Main"] = "main";
  SdkEnvironmentNames["Ropsten"] = "ropsten";
  SdkEnvironmentNames["Rinkeby"] = "rinkeby";
  SdkEnvironmentNames["Kovan"] = "kovan";
  SdkEnvironmentNames["Sokol"] = "sokol";
  SdkEnvironmentNames["Xdai"] = "xdai";
})(SdkEnvironmentNames = exports.SdkEnvironmentNames || (exports.SdkEnvironmentNames = {}));

var mainConfig = {
  apiOptions: {
    host: 'archanova.run',
    ssl: true,
    reconnectTimeout: 3000
  },
  ensOptions: {
    supportedRootNames: ['myarchanova.xyz']
  },
  ethOptions: {
    networkId: '1'
  },
  apiWebSocketConstructor: null,
  storageOptions: {
    namespace: '@archanova:main'
  },
  storageAdapter: null
};
exports.main = new modules_1.Environment(Object.create(mainConfig)).extendConfig('ethOptions', {
  contractAddresses: _defineProperty({}, contracts_1.ContractNames.ENSRegistry, '0x314159265dD8dbb310642f98f50C066173C1259b')
});
exports.ropsten = new modules_1.Environment(Object.create(mainConfig)).extendConfig('apiOptions', {
  host: 'ropsten.archanova.run'
}).extendConfig('ensOptions', {
  supportedRootNames: ['archanova.ropsten']
}).extendConfig('ethOptions', {
  networkId: '3'
}).extendConfig('storageOptions', {
  namespace: '@archanova:ropsten'
});
exports.rinkeby = new modules_1.Environment(Object.create(mainConfig)).extendConfig('apiOptions', {
  host: 'rinkeby.archanova.run'
}).extendConfig('ensOptions', {
  supportedRootNames: ['archanova.rinkeby']
}).extendConfig('ethOptions', {
  networkId: '4'
}).extendConfig('storageOptions', {
  namespace: '@archanova:rinkeby'
});
exports.kovan = new modules_1.Environment(Object.create(mainConfig)).extendConfig('apiOptions', {
  host: 'kovan.archanova.run'
}).extendConfig('ensOptions', {
  supportedRootNames: ['archanova.kovan']
}).extendConfig('ethOptions', {
  networkId: '42'
}).extendConfig('storageOptions', {
  namespace: '@archanova:kovan'
});
exports.sokol = new modules_1.Environment(Object.create(mainConfig)).extendConfig('apiOptions', {
  host: 'sokol.archanova.run'
}).extendConfig('ensOptions', {
  supportedRootNames: ['archanova.sokol']
}).extendConfig('ethOptions', {
  networkId: '77'
}).extendConfig('storageOptions', {
  namespace: '@archanova:sokol'
});
exports.xdai = new modules_1.Environment(Object.create(mainConfig)).extendConfig('apiOptions', {
  host: 'xdai.archanova.run'
}).extendConfig('ensOptions', {
  supportedRootNames: ['archanova.xdai']
}).extendConfig('ethOptions', {
  networkId: '100'
}).extendConfig('storageOptions', {
  namespace: '@archanova:xdai'
});